if (process.env.NODE_ENV !== 'development') {
    var amplitudeScript = document.createElement('script')
    amplitudeScript.src = 'https://cdn.amplitude.com/script/15f658b9788ef003adc796044e53ba70.js'
    amplitudeScript.onload = function () {
        window.amplitude.add(window.sessionReplay.plugin({ sampleRate: 1 }))
        window.amplitude.init('15f658b9788ef003adc796044e53ba70', {
            fetchRemoteConfig: true,
            autocapture: true,
        })
    }
    document.head.appendChild(amplitudeScript)
}
